








import { Component, Vue } from "vue-property-decorator";

@Component
export default class FolderAlreadySelectedModal extends Vue {
    name = "";

    open(name: string) {
        this.name = name;
        this.$bvModal.show("modal-folderAlreadySelected");
    }

    confirm() {
        this.$bvModal.hide("modal-folderAlreadySelected");
        this.name = "";
    }
}
